var _path, _path2, _path3, _circle, _ellipse, _path4, _path5, _ellipse2, _path6, _path7, _ellipse3, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _path16, _ellipse4, _circle3, _path17, _path18, _ellipse5, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWomanWithPhoneAndNatureYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 938.192 761.036"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M0 758.447h937.724v2H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M474.705 206.206h-4V96.66a63.4 63.4 0 0 0-63.401-63.402H175.217a63.4 63.4 0 0 0-63.402 63.402v600.975a63.4 63.4 0 0 0 63.402 63.401h232.087a63.4 63.4 0 0 0 63.402-63.401V284.182h3.998Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M457.214 97.103v600.09a47.35 47.35 0 0 1-47.35 47.35h-233.21a47.34 47.34 0 0 1-47.34-47.35V97.103a47.34 47.34 0 0 1 47.34-47.35h28.3a22.486 22.486 0 0 0 20.83 30.99h132.96a22.48 22.48 0 0 0 20.82-30.99h30.3a47.35 47.35 0 0 1 47.35 47.35"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 234.724,
  cy: 148.943,
  r: 62,
  fill: "#ff6584"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 481.529,
  cy: 511.478,
  fill: "#3f3d56",
  rx: 83.937,
  ry: 41.137,
  transform: "rotate(-84.369 377.742 548.96)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M340.924 579.097c-6.697-99.992 19.2-196.412 19.461-197.374l3.137.855c-.261.957-26.013 96.87-19.355 196.303Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m349.466 443.739 38.973-16.152 1.245 3.003-38.973 16.152zM311.089 432.86l1.808-2.701 35.062 23.462-1.808 2.702z"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 395.866,
  cy: 372.954,
  fill: "#e6e6e6",
  rx: 164.171,
  ry: 80.46,
  transform: "rotate(-84.369 292.08 410.436)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M247.539 571.523c-13.081-195.316 37.5-383.648 38.012-385.527l3.136.854c-.51 1.875-50.948 189.702-37.905 384.457Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m263.29 308.316 76.228-31.59 1.245 3.003-76.228 31.59zM188.497 284.307l1.808-2.702 68.577 45.888-1.808 2.702z"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 595.206,
  cy: 293.318,
  fill: "#ffbd01",
  rx: 224.655,
  ry: 110.103,
  transform: "rotate(-84.369 491.419 330.8)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M441.057 590.603c-17.893-267.175 51.296-524.795 51.997-527.366l3.136.855c-.7 2.566-69.745 259.68-51.89 526.295Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m462.244 231.019 104.31-43.23 1.244 3.004-104.31 43.229zM359.998 197.113l1.808-2.702 93.843 62.792-1.808 2.702z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m129.314 587.24-2 112.503c0 26.62 23.19 48.2 49.34 48.2h233.21c26.15 0 49.35-21.58 49.35-48.2l-2-111.515c-117.571-45.572-226.289-42.714-327.9-.987"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m626.83 196.076 12.413-9.928c-9.643-1.064-13.606 4.195-15.227 8.358-7.534-3.128-15.736.971-15.736.971l24.837 9.017a18.8 18.8 0 0 0-6.287-8.418M323.427 108.426l12.413-9.928c-9.643-1.064-13.606 4.195-15.227 8.358-7.534-3.128-15.736.972-15.736.972l24.837 9.016a18.8 18.8 0 0 0-6.287-8.418M818.31 69.321l12.414-9.928c-9.643-1.064-13.606 4.195-15.227 8.358-7.534-3.128-15.736.971-15.736.971L824.6 77.74a18.8 18.8 0 0 0-6.288-8.418"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb9b9",
  d: "m798.687 525.966-.212 16.913a11.038 11.038 0 0 1-13.33 10.66 11.038 11.038 0 0 1-7.65-15.594l5.653-11.716 11.717-85.025-4.497-56.815 21.998-1.055 4.678 64.989ZM690.906 615.823l-21.15 113.882 10.575-1.627 39.045-114.695zM792.179 617.043l13.422 116.729 11.388-1.627 2.847-115.915z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M912.568 582.879c-30.32 24.359-65.824 60.135-101.172 46.807-36.887-13.909-79.458-14.788-127.405-8.576 11.452-71.83 25.593-139.794 43.926-201.733l61.008 9.761c.944 1.043-1.334 6.684-.407 7.728 17.15 19.313 34.64 34.282 45.21 54.174a263.1 263.1 0 0 0 62.1 77.674Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M938.192 595.487c-30.32 25.048-93.888 66.863-129.236 53.158-36.887-14.301-80.678-13.18-128.625-6.792q3.413-22.011 7.28-43.743c10.393-58.367 199.819-37.864 225.364-15.638Z",
  opacity: 0.5
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M816.09 386.976c-11.407-3.335-23.035-1.68-34.818 3.443l4.268-32.074a13.42 13.42 0 0 1 11.692-14.953 13.42 13.42 0 0 1 14.953 11.691Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 764.115,
  cy: 296.954,
  r: 22.776,
  fill: "#ffb9b9"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb9b9",
  d: "m806.414 360.403-50.026-11.795c7.426-10.677 5.906-23.19 0-36.605l24.403-4.88c2.7 9.258 5.978 17.73 10.575 24.402Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m788.925 432.392-61.821-8.948 2.056-11.578c-.975-30.163 3.995-54.852 13.4-75.46l54.5 3.254a40.506 40.506 0 0 1 11.71 48.08l-19.031 37.331ZM681.766 759.076c-2.853 1.302-5.242-9.246-7.649-6.882-6.73 6.615-17.038 8.056-26.023 5.168l3.145-.036a4.21 4.21 0 0 1-2.652-5.483 4.21 4.21 0 0 1 2.919-2.604l7.158-1.79 11.24-19.766 12.25-1.55.309.505a31.58 31.58 0 0 1 3.385 25.826c-1.02 3.264-2.406 5.847-4.082 6.612M816.797 759.076c-2.853 1.302-5.242-9.246-7.649-6.882-6.73 6.615-17.038 8.056-26.022 5.168l3.144-.036a4.21 4.21 0 0 1-2.652-5.483 4.21 4.21 0 0 1 2.92-2.604l7.158-1.79 11.24-19.766 12.249-1.55.31.505a31.58 31.58 0 0 1 3.384 25.826c-1.02 3.264-2.406 5.847-4.082 6.612"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M792.465 392.94h-.583c-11-9.53-20.558-20.215-12.84-33.592-6.546-16.616-13.845-33.872-13.403-44.547a31.3 31.3 0 0 0-7.112-21.766c-6.957-8.126-8.505-11.755-21.211-8.682a24.076 24.076 0 0 1 24.948-24.394l7.938.289c6.073.22 25.48 2.703 29.647 6.71a19.33 19.33 0 0 1 5.534 16.255c-.779 6.626 1.311 12.476 6.896 17.382 10.692 11.056 15.102 22.528 9.04 34.693-4.576 12.879-4.357 23.48 7.446 28.576 3.833 14.71-21.098 29.076-36.3 29.076"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 794.988,
  cy: 521.532,
  fill: "#3f3d56",
  rx: 7.782,
  ry: 15.878,
  transform: "rotate(-42.766 640.81 653.95)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 695.701,
  cy: 390.804,
  r: 22.828,
  fill: "#ffbd01"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M734.036 536.273a120.3 120.3 0 0 1-28.33-17.975c-17.275-14.937-29.82-36.372-30.753-59.54-.896-22.232 8.525-43.133 18.49-62.453q1.881-3.646 3.8-7.272c.487-.923 1.996-.303 1.507.626-10.339 19.62-21.186 40.354-22.167 62.978-1.034 23.847 10.617 46.578 27.955 62.444a117.3 117.3 0 0 0 30.034 19.644"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "m685.929 390.426 1.059-.245 3.438 14.881-1.06.245z"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 831.608,
  cy: 565.389,
  fill: "#3f3d56",
  rx: 7.782,
  ry: 15.878,
  transform: "rotate(-7.135 208.944 1580.44)"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb9b9",
  d: "m727.917 509.669-2.265 16.762a11.038 11.038 0 0 1-14.527 8.96 11.038 11.038 0 0 1-5.697-16.407l7.034-10.942 21.963-82.971 2.44-56.94 21.963 1.626-3.254 65.075Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M761.675 380.332c-10.916-4.696-22.66-4.466-34.978-.814l8.134-31.317a13.42 13.42 0 0 1 13.422-13.422 13.42 13.42 0 0 1 13.422 13.422Z"
})));
export default SvgWomanWithPhoneAndNatureYellowIcon;